import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCO = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M0 25C0 11.193 11.193 0 25 0c13.806 0 25 11.193 25 25l-25 2.174L0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M3.345 37.5C7.668 44.972 15.746 50 25 50c9.253 0 17.331-5.028 21.654-12.5L25 35.87 3.345 37.5Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M46.654 37.5A24.884 24.884 0 0 0 50 25H0c0 4.553 1.218 8.822 3.345 12.5h43.31Z"
}));
FlagCO.displayName = 'FlagCO';
export default withFlagWrapper(FlagCO);
//# sourceMappingURL=index.js.map